import Vue from 'vue'
import master from './masterMutation.js'
// master-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  async changeAutoLogout(store, payload) {
    await store.commit('changeAutoLogoutSecond', payload.autoLogoutSecond)
    await store.commit('changeAutoLogoutEnableFlag', payload.showSleepChange)
    await store.dispatch('updateAutoLogoutMaster', store.state.logoutFlagMaster)
  },
  async changeShowRates(store, payload) {
    await store.commit('changeShowRates', payload)
    await store.dispatch('updateRatesMaster', store.state.ratesFlagMaster)
  },
  async changeKeyboardType(store, payload) {
    await store.commit('changeKeyboardType', payload)
    await store.dispatch('updateKeyboardType', store.state.masterData)
  },
  async changeDispPositionJob(store, payload) {
    await store.commit('changePositionJobEnable', payload)
    await store.dispatch('updatePositionJobEnable', store.state.masterData)
  },
  successLogoutFlag(store) {
    store.commit('successLogoutFlag')
  },
  changeUnauthorizedFlag(store) {
    store.commit('changeUnauthorizedFlag')
  },
  async changeRateFlag(store, value) {
    await store.commit('changeRateFlag', value)
  },
  async clearRateFlag(store) {
    await store.commit('clearRateFlag')
  },
  async loginCareRings(store, payload) {
    await store.commit('setLoginUser', payload)
    const config = {
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          companyId: payload.companyId,
          userId: payload.userId,
          password: payload.password,
          devicePhysicalId: store.state.header.devicePhysicalId,
          deviceId: store.state.header.deviceId
        }
      ]
    }
    var response = await Vue.http.post(URL + '/v2/admin/login', data, config)
    // 成功
    // 追加後の処理
    store.commit('successLoginFlag', response)
  },
  async logoutCareRings(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    await Vue.http.post(URL + '/v2/admin/logout', data, config)
    // 成功
    // 追加後の処理
    store.commit('successLogoutFlag')
  },
  async setMaster(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/define/detail',
      data,
      config
    )
    // 成功
    store.commit('setMasters', response)
  },
  async updateAutoLogoutMaster(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          autoLogoutSecond: payload.autoLogoutSecond,
          autoLogoutEnableFlag: payload.autoLogoutEnableFlag
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async updateRatesMaster(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          ratingQuarityEnableFlag: payload.ratingQuarityEnableFlag
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async updateLogoutLabelValue(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          logoutLabelValue: payload.logoutLabelValue
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async updateKeyboardType(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          keyboardType: payload.keyboardType
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async updatePositionJobEnable(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          positionJobEnableFlag: payload.positionJobEnableFlag
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async updatePasswordEnableFlagMaster(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          passwordEnableFlag: payload.flag,
          initLoginPassword: payload.newPassword
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/password', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setMaster')
  },
  async changePassword(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          initLoginPassword: payload
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/corporation/password', data, config)
    // 成功
    await store.dispatch('setMaster')
  },
  async writeLog(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    var eventDateTime = new Date()
    var eventDate = Date.parse(eventDateTime)
    const data = {
      header,
      data: [
        {
          division: 'C',
          eventNumber: payload.eventNumber,
          eventType: payload.eventType,
          eventDate: eventDate,
          level: 1,
          status: 0,
          reason: payload.reason,
          companyId: store.state.loginCompanyId,
          userId: store.state.loginUser.adminUserId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/log/regist', data, config)
    // 成功
  },
  async setStatus(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/status/detail',
      data,
      config
    )
    // 成功
    store.commit('setStatus', response)
  },
  async updateStatusLabelValue(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          status: [
            {
              statusId1: payload.statusId1,
              statusName1: payload.statusName1,
              statusId2: payload.statusId2,
              statusName2: payload.statusName2
            }
          ]
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/status/update', data, config)
    // 成功
    // 更新後の処理
    await store.dispatch('setStatus')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/masterModules/actions.js